<template>
  <div
    class="flex flex-col items-center gap-[0.75rem] cursor-pointer dashboard-card-shadow"
    :class="classFormat"
  >
    <Skeleton height="4.5rem" v-if="loading"/>
    <template v-else>
      <div class="text-2xl font-bold font-montserrat text-university-primary" :data-testid="`${dataTestId}-number`">
        {{ formattedNumber }}
      </div>
      <div class="flex flex-row items-center gap-2" :data-testid="`${dataTestId}-details`">
        <div class="text-2xl flex items-center justify-center" :data-testid="`${dataTestId}-icon`">
          <span v-if="muiIconName" :class="muiIconClass" class="material-symbols-outlined">{{muiIconName}}</span>
          <slot v-else name="icon" />
        </div>
        <div
          class="truncate font-montserrat font-medium text-sm text-university-primary text-center"
          :data-testid="`${dataTestId}-description`"
        >
          {{ description }}
        </div>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import Skeleton from "primevue/skeleton";
import { computed } from "vue";
import { numberFormatter } from "@/util/formatter";

const props = defineProps({
  number: {
    type: Number,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
  dataTestId: {
    type: String,
    required: true,
  },
  classFormat: {
    type: String,
    default: "bg-blue-100 rounded-lg px-[1rem] pt-[1rem] pb-[0.875rem]",
  },
  loading: {
    type: Boolean,
    default: false,
    required: false,
  },
  muiIconName: {
    type: String,
    required: false,
  },
  muiIconClass: {
    type: String,
    required: false,
    default: "",
  },
});

const formattedNumber = computed(() => numberFormatter(props.number));
</script>

<style scoped>
.dashboard-card-shadow {
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1)
}
</style>
